module.exports = __webpack_public_path__ + "img/arrow_left_cyan.f0cb30f9.svg";